import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import moment from 'moment-timezone';
import { string } from "prop-types";

/**
 * Container component for the pharmacy page.
 * 
 */


const StatusDisplay = ({ status }) => {
    switch (status.toUpperCase()) {
        case "APPROVED":
        case "PROCESSED":
        case "PAY":
            return <div id="claim-appeal-status" className="bold-text status-detail-label claim-approved"><span className="icon-check status-checkmark"></span>{status}</div>;
        case "CLOSED":
            return <div id="claim-appeal-status" className="bold-text status-detail-label claim-closed">{status}</div>;
        case "ENTERED":
            return <div id="claim-appeal-status" className="bold-text status-detail-label claim-entered">{status}</div>;
        case "IN ADJUDICATION":
            return <div id="claim-appeal-status" className="bold-text status-detail-label claim-in-adjudication">{status}</div>;
        case "OVERPAY":
            return <div id="claim-appeal-status" className="bold-text status-detail-label claim-overpay">{status}</div>;
        case "PENDING":
        case "PEND":
            return <div id="claim-appeal-status" className="bold-text status-detail-label claim-pending">{status}</div>;
        case "DENIED":
        case "DENY":
        case "REJECT":
        case "REJECTED":
            return <div id="claim-appeal-status" className="bold-text status-detail-label claim-reject"><span className="icon-error status-icon"></span>{status}</div>;
        default:
            return <div id="claim-appeal-status" className="bold-text status-detail-label"> - </div>
    }

    return "";
}

class ClaimAppeal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            claimId: props.location.state.claimId,
            description: "",
            showLoader: true,
            showSubmitLoader: false,
            shouldLoadData: true,
            appealIssueId: null,
            showAppealError: false,
            maxDescriptionLength: 999
        };
        this.cancelAppeal = this.cancelAppeal.bind(this);
        this.submitAppeal = this.submitAppeal.bind(this);
        this.goToSupportPage = this.goToSupportPage.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ClaimAppeal.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        const { hpIdentity, isFetching } = this.props;

        if (this.props.claimDetail !== prevProps.claimDetail) {
            this.setState({ showLoader: false });
        }

        if (this.state.showSubmitLoader && this.props.appealIssueId !== prevProps.appealIssueId) {
            this.setState({ showSubmitLoader: false, appealIssueId: this.props.appealIssueId });
        } else if (this.state.showSubmitLoader && !isFetching && this.props.error !== prevProps.error) {
            this.setState({ showSubmitLoader: false, showAppealError: true });
        }

        if (hpIdentity && this.state.shouldLoadData && !isFetching) {
            this.props.getClaimDetail(this.state.claimId);
            this.setState({ shouldLoadData: false });
        }
    }

    cancelAppeal() {
        this.props.history.goBack();
    }

    goToSupportPage() {
        this.props.history.replace('/support');
    }

    submitAppeal() {
        this.setState({ showSubmitLoader: true, showAppealError: false });
        let relatedClaims = [this.state.claimId];
        let relatedMembers = [this.props.claimDetail.patientIdentifier, this.props.hpIdentity.memberUserClaims.memberHccId];
        let relatedUserAccountName = this.props.hpIdentity.username;
        let description = document.getElementById("appeal-message").value;

        this.props.submitAppeal(relatedClaims, relatedMembers, relatedUserAccountName, description);
    }

    goBack() {
        this.props.history.goBack();
    }

    render() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="claim-wrapper">
                            {this.state.showLoader ?
                                <div id="claim-appeal-spinner" className="spinner">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                </div>
                                :
                                !this.state.appealIssueId ? 
                                <div className="claim-container">
                                    <div className="row">
                                        <span className="link-text cursor-pointer" onClick={() => this.goBack()}>{'< Back'}</span>
                                    </div>
                                    <div className="hp-title">
                                        Why would you like to appeal this claim?
                                    </div>

                                    <hr></hr>

                                    <div className="row claim-status-detail">
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Member</div>
                                                <div id="claim-appeal-patient-name" className="status-detail-label">{this.props.claimDetail.patientName.trim() == "" ? "-" : this.props.claimDetail.patientName}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Member ID</div>
                                                <div id="claim-appeal-member-hcc-id" className="status-detail-label">{this.props.hpIdentity.memberUserClaims.memberHccId.trim() == "" ? "-" : this.props.hpIdentity.memberUserClaims.memberHccId}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Claim ID</div>
                                                <div id="claim-appeal-claim-id" className="status-detail-label">{this.props.claimDetail.claimId.trim() == "" ? "-" : this.props.claimDetail.claimId}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Status</div>
                                                <StatusDisplay status={this.props.claimDetail.claimStatus} />
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Processed Date</div>
                                                <div id="claim-appeal-processing-date" className="status-detail-label">{moment(this.props.claimDetail.processingDate).format("MM/DD/YYYY")}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Received Date</div>
                                                <div id="claim-appeal-receipt-date" className="status-detail-label">{moment(this.props.claimDetail.receiptDate).format("MM/DD/YYYY")}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Total Charged</div>
                                                <div id="claim-appeal-billed-amount" className="status-detail-label">{this.props.claimDetail.billedAmount !== null ? formatter.format(this.props.claimDetail.billedAmount) : ""}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                        <div className="col-12 col-sm-6">
                                            <div className="status-column">
                                                <div className="bold-text claim-label">Total Paid</div>
                                                <div id="claim-appeal-member-amount" className="status-detail-label">{this.props.claimDetail.memberAmount !== null ? formatter.format(this.props.claimDetail.memberAmount) : ""}</div>
                                            </div>
                                            <hr></hr>
                                        </div>
                                    </div>
                                    {this.state.showSubmitLoader ? 
                                    <div id="claim-appeal-form-spinner" className="spinner">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                    :
                                    <div id="claim-appeal-form" className="appeal-form">
                                        <div className="large-message-input-container appeal-message-container">
                                            <div className="appeal-input-prompt">Please enter your reason for appealing this claim. (maximum of 1000 characters)</div>
                                                    <textarea id="appeal-message" className="large-message-input appeal-message" value={this.state.description} maxLength={this.state.maxDescriptionLength} onChange={(event) => { this.setState({ description: event.target.value }) }} />
                                        </div>
                                        <div className="appeal-button-container">
                                                    <input type="button" id="appeal-cancel" onClick={() => { this.cancelAppeal(); }} className="btn appeal-cancel-button" value="Cancel" />
                                                    <input type="button" id="appeal-submit" onClick={() => { this.submitAppeal(); }} className="btn appeal-button" value="Send Message" disabled={this.props.isReadOnly} />
                                        </div>
                                        <div className="bold-text entered-style appeal-error-container">
                                            {this.state.showAppealError ? "Sorry, we are unable to submit an appeal at this time. Please try again later." : ""}
                                        </div>
                                    </div>
                                    }
                                </div>
                                :
                                    <div id="claim-appeal-submitted-message" className="claim-container">
                                        <div className="appeal-banner">
                                            <span className="icon-list-check appeal-checkmark"></span>Thanks, your appeal was submitted!
                                        </div>
                                        <div className="appeal-submit-complete-container">
                                            <div className="appeal-complete-prompt">
                                                Your appeal request will be processed shortly and a response will appear under <span id="appeal-support-link" className="link-text cursor-pointer" onClick={() => { this.goToSupportPage() }}>Support</span>. Your request ID is {this.state.appealIssueId}.
                                            </div>
                                            <div className="appeal-button-container">
                                                <input type="button" id="appeal-see-all-claims" onClick={() => { this.cancelAppeal(); }} className="btn appeal-button" value="See All Claims" />
                                            </div>
                                        </div>
                                    </div>
                                }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        claimDetail: state.healthPlanServices.claimDetail,
        error: state.healthPlanServices.error,
        appealSubmitStatus: state.healthPlanServices.appealSubmitStatus,
        appealIssueId: state.healthPlanServices.appealIssueId,
        hpIdentity: state.session.healthPlanUserProfile,
        isFetching: state.healthPlanServices.isFetching,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getClaimDetail: (claimId) => dispatch({ type: types.HP_GET_CLAIM_DETAIL_START, claimId: claimId }),
        submitAppeal: (relatedClaims, relatedMembers, relatedUserAccountName, description) => dispatch({ type: types.HP_SUBMIT_CLAIM_APPEAL_START, relatedClaims: relatedClaims, relatedMembers: relatedMembers, relatedUserAccountName: relatedUserAccountName, description: description })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClaimAppeal));
